'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ('value' in descriptor)
                descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function (Constructor, protoProps, staticProps) {
        if (protoProps)
            defineProperties(Constructor.prototype, protoProps);
        if (staticProps)
            defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
var _promisePolyfill = require('promise-polyfill');
var _promisePolyfill2 = _interopRequireDefault(_promisePolyfill);
var _utils = require('./utils');
var _utils2 = _interopRequireDefault(_utils);
var _icons = require('./icons');
var _icons2 = _interopRequireDefault(_icons);
var _options = require('./options');
var _options2 = _interopRequireDefault(_options);
var _template = require('./template');
var _template2 = _interopRequireDefault(_template);
var _bar = require('./bar');
var _bar2 = _interopRequireDefault(_bar);
var _user = require('./user');
var _user2 = _interopRequireDefault(_user);
var _lrc = require('./lrc');
var _lrc2 = _interopRequireDefault(_lrc);
var _controller = require('./controller');
var _controller2 = _interopRequireDefault(_controller);
var _timer = require('./timer');
var _timer2 = _interopRequireDefault(_timer);
var _events = require('./events');
var _events2 = _interopRequireDefault(_events);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError('Cannot call a class as a function');
    }
}
var instances = [];
var APlayer = function () {
    function APlayer(options) {
        _classCallCheck(this, APlayer);
        this.options = (0, _options2.default)(options);
        this.container = this.options.container;
        this.playIndex = 0;
        this.paused = true;
        this.playedPromise = _promisePolyfill2.default.resolve();
        this.randomOrder = _utils2.default.randomOrder(this.options.audio.length);
        this.container.classList.add('aplayer');
        if (this.options.lrc) {
            this.container.classList.add('aplayer-withlrc');
        }
        if (this.options.audio.length > 1) {
            this.container.classList.add('aplayer-withlist');
        }
        if (_utils2.default.isMobile) {
            this.container.classList.add('aplayer-mobile');
        }
        this.arrow = this.container.offsetWidth <= 300;
        if (this.arrow) {
            this.container.classList.add('aplayer-arrow');
        }
        if (this.options.mini) {
            this.container.classList.add('aplayer-narrow');
        }
        this.container = this.options.container;
        if (this.options.lrc === 2 || this.options.lrc === true) {
            var lrcEle = this.container.getElementsByClassName('aplayer-lrc-content');
            for (var i = 0; i < lrcEle.length; i++) {
                if (this.options.audio[i]) {
                    this.options.audio[i].lrc = lrcEle[i].innerHTML;
                }
            }
        }
        this.template = new _template2.default({
            container: this.container,
            options: this.options,
            randomOrder: this.randomOrder
        });
        if (this.template.info.offsetWidth < 200) {
            this.template.time.classList.add('aplayer-time-narrow');
        }
        if (this.options.lrc) {
            this.lrc = new _lrc2.default({
                container: this.template.lrc,
                async: this.options.lrc === 3,
                content: this.options.audio.map(function (item) {
                    return item.lrc;
                }),
                player: this
            });
        }
        this.events = new _events2.default();
        this.user = new _user2.default(this);
        this.bar = new _bar2.default(this.template);
        this.controller = new _controller2.default(this);
        this.timer = new _timer2.default(this);
        this.initAudio();
        if (this.options.order === 'random') {
            this.switchAudio(this.randomOrder[0]);
        } else {
            this.switchAudio(0);
        }
        if (this.options.autoplay) {
            this.play();
        }
        instances.push(this);
    }
    _createClass(APlayer, [
        {
            key: 'initAudio',
            value: function initAudio() {
                var _this = this;
                this.audio = document.createElement('audio');
                this.audio.preload = this.options.preload;
                var _loop = function _loop(i) {
                    _this.audio.addEventListener(_this.events.audioEvents[i], function () {
                        _this.events.trigger(_this.events.audioEvents[i]);
                    });
                };
                for (var i = 0; i < this.events.audioEvents.length; i++) {
                    _loop(i);
                }
                this.on('play', function () {
                    if (_this.paused) {
                        _this.play();
                    }
                });
                this.on('pause', function () {
                    if (!_this.paused) {
                        _this.pause();
                    }
                });
                this.on('durationchange', function () {
                    if (_this.audio.duration !== 1) {
                        _this.template.dtime.innerHTML = _utils2.default.secondToTime(_this.audio.duration);
                    }
                });
                this.on('progress', function () {
                    var percentage = _this.audio.buffered.length ? _this.audio.buffered.end(_this.audio.buffered.length - 1) / _this.audio.duration : 0;
                    _this.bar.set('loaded', percentage, 'width');
                });
                this.on('error', function () {
                    _this.template.author.innerHTML = ' - Error happens \u2565﹏\u2565';
                });
                this.on('ended', function () {
                    if (_this.options.loop === 'none') {
                        if (_this.options.order === 'list') {
                            if (_this.playIndex < _this.options.audio.length - 1) {
                                _this.switchAudio((_this.playIndex + 1) % _this.options.audio.length);
                                _this.play();
                            } else {
                                _this.switchAudio((_this.playIndex + 1) % _this.options.audio.length);
                                _this.pause();
                            }
                        } else if (_this.options.order === 'random') {
                            if (_this.randomOrder.indexOf(_this.playIndex) < _this.randomOrder.length - 1) {
                                _this.switchAudio(_this.nextRandomNum());
                                _this.play();
                            } else {
                                _this.switchAudio(_this.nextRandomNum());
                                _this.pause();
                            }
                        }
                    } else if (_this.options.loop === 'one') {
                        _this.switchAudio(_this.playIndex);
                        _this.play();
                    } else if (_this.options.loop === 'all') {
                        if (_this.options.order === 'list') {
                            _this.switchAudio((_this.playIndex + 1) % _this.options.audio.length);
                        } else if (_this.options.order === 'random') {
                            _this.switchAudio(_this.nextRandomNum());
                        }
                        _this.play();
                    }
                });
                this.volume(this.user.get('volume'), true);
            }
        },
        {
            key: 'switchAudio',
            value: function switchAudio(index) {
                var _this2 = this;
                this.handlePlayPromise(function () {
                    _this2.events.trigger('switchaudio', index);
                    if (typeof index !== 'undefined') {
                        _this2.playIndex = index;
                    }
                    if (_this2.options.audio[_this2.playIndex].cover) {
                        _this2.template.pic.style.backgroundImage = 'url(\'' + _this2.options.audio[_this2.playIndex].cover + '\')';
                    } else {
                        _this2.template.pic.style.backgroundImage = '';
                    }
                    _this2.template.title.innerHTML = _this2.options.audio[_this2.playIndex].name;
                    _this2.template.author.innerHTML = _this2.options.audio[_this2.playIndex].artist ? ' - ' + _this2.options.audio[_this2.playIndex].artist : '';
                    var light = _this2.container.getElementsByClassName('aplayer-list-light')[0];
                    if (light) {
                        light.classList.remove('aplayer-list-light');
                    }
                    _this2.container.querySelectorAll('.aplayer-list li')[_this2.playIndex].classList.add('aplayer-list-light');
                    _this2.template.list.scrollTop = _this2.playIndex * 33;
                    _this2.audio.src = _this2.options.audio[_this2.playIndex].url;
                    _this2.seek(0);
                    var playPromise = void 0;
                    if (!_this2.paused) {
                        playPromise = _promisePolyfill2.default.resolve(_this2.audio.play()).catch(function (err) {
                            console.error(err);
                            _this2.pause();
                        });
                    }
                    _this2.lrc && _this2.lrc.switch(_this2.playIndex);
                    if (_this2.audio.duration !== 1) {
                        _this2.template.dtime.innerHTML = _this2.audio.duration ? _utils2.default.secondToTime(_this2.audio.duration) : '00:00';
                    }
                    return playPromise;
                });
            }
        },
        {
            key: 'seek',
            value: function seek(time) {
                time = Math.max(time, 0);
                if (this.audio.duration) {
                    time = Math.min(time, this.audio.duration);
                }
                this.audio.currentTime = time;
                if (isNaN(this.audio.duration)) {
                    this.bar.set('played', 0, 'width');
                } else {
                    this.bar.set('played', time / this.audio.duration, 'width');
                }
                this.template.ptime.innerHTML = _utils2.default.secondToTime(time);
            }
        },
        {
            key: 'play',
            value: function play() {
                var _this3 = this;
                this.handlePlayPromise(function () {
                    if (_this3.paused) {
                        _this3.paused = false;
                        _this3.template.button.classList.remove('aplayer-play');
                        _this3.template.button.classList.add('aplayer-pause');
                        _this3.template.button.innerHTML = '';
                        setTimeout(function () {
                            _this3.template.button.innerHTML = _icons2.default.pause;
                        }, 100);
                    }
                    var playPromise = _promisePolyfill2.default.resolve(_this3.audio.play()).catch(function (err) {
                        console.error(err);
                        _this3.pause();
                    });
                    _this3.timer.enable('loading');
                    _this3.timer.enable('progress');
                    if (_this3.options.mutex) {
                        for (var i = 0; i < instances.length; i++) {
                            if (_this3 !== instances[i]) {
                                instances[i].pause();
                            }
                        }
                    }
                    return playPromise;
                });
            }
        },
        {
            key: 'pause',
            value: function pause() {
                var _this4 = this;
                this.handlePlayPromise(function () {
                    if (!_this4.paused) {
                        _this4.paused = true;
                        _this4.template.button.classList.remove('aplayer-pause');
                        _this4.template.button.classList.add('aplayer-play');
                        _this4.template.button.innerHTML = '';
                        setTimeout(function () {
                            _this4.template.button.innerHTML = _icons2.default.play;
                        }, 100);
                    }
                    _this4.audio.pause();
                    _this4.timer.disable('loading');
                    _this4.timer.disable('progress');
                });
            }
        },
        {
            key: 'switchVolumeIcon',
            value: function switchVolumeIcon() {
                if (this.volume() >= 0.95) {
                    this.template.volumeButton.innerHTML = _icons2.default.volumeUp;
                } else if (this.volume() > 0) {
                    this.template.volumeButton.innerHTML = _icons2.default.volumeDown;
                } else {
                    this.template.volumeButton.innerHTML = _icons2.default.volumeOff;
                }
            }
        },
        {
            key: 'volume',
            value: function volume(percentage, nostorage) {
                percentage = parseFloat(percentage);
                if (!isNaN(percentage)) {
                    percentage = Math.max(percentage, 0);
                    percentage = Math.min(percentage, 1);
                    this.bar.set('volume', percentage, 'height');
                    if (!nostorage) {
                        this.user.set('volume', percentage);
                    }
                    this.audio.volume = percentage;
                    if (this.audio.muted) {
                        this.audio.muted = false;
                    }
                    this.switchVolumeIcon();
                }
                return this.audio.muted ? 0 : this.audio.volume;
            }
        },
        {
            key: 'on',
            value: function on(name, callback) {
                this.events.on(name, callback);
            }
        },
        {
            key: 'toggle',
            value: function toggle() {
                if (this.template.button.classList.contains('aplayer-play')) {
                    this.play();
                } else if (this.template.button.classList.contains('aplayer-pause')) {
                    this.pause();
                }
            }
        },
        {
            key: 'isMultiple',
            value: function isMultiple() {
                return this.options.audio.length > 1;
            }
        },
        {
            key: 'nextRandomNum',
            value: function nextRandomNum() {
                if (this.isMultiple()) {
                    var index = this.randomOrder.indexOf(this.playIndex);
                    if (index === this.randomOrder.length - 1) {
                        return this.randomOrder[0];
                    } else {
                        return this.randomOrder[index + 1];
                    }
                } else {
                    return 0;
                }
            }
        },
        {
            key: 'addAudio',
            value: function addAudio(newMusic) {
                this.events.trigger('addaudio', newMusic);
                var wasSingle = !this.isMultiple();
                this.options.audio = this.options.audio.concat(newMusic);
                var newItemHTML = '';
                for (var i = 0; i < newMusic.length; i++) {
                    newItemHTML += '<li><span class="aplayer-list-cur" style="background: ' + this.options.theme + ';"></span><span class="aplayer-list-index">' + (this.options.audio.length - newMusic.length + i + 1) + '</span><span class="aplayer-list-title">' + newMusic[i].name + '</span><span class="aplayer-list-author">' + newMusic[i].artist + '</span></li>';
                }
                this.template.listOl.innerHTML += newItemHTML;
                if (wasSingle && this.isMultiple()) {
                    this.container.classList.add('aplayer-withlist');
                    this.audio.loop = false;
                }
                var songListLength = this.container.querySelectorAll('.aplayer-list li').length;
                this.template.list.style.height = songListLength * 33 - 1 + 'px';
                this.randomOrder = _utils2.default.randomOrder(this.options.audio.length);
            }
        },
        {
            key: 'removeAudio',
            value: function removeAudio(index) {
                this.events.trigger('removeaudio', index);
                if (this.options.audio[index] && this.options.audio.length > 1) {
                    var list = this.container.querySelectorAll('.aplayer-list li');
                    this.options.audio.splice(index, 1);
                    if (index === this.playIndex) {
                        if (this.options.audio[index + 1]) {
                            this.switchAudio(index);
                        } else {
                            this.switchAudio(index - 1);
                        }
                    }
                    if (this.playIndex > index) {
                        this.playIndex--;
                    }
                    list[index].remove();
                    for (var i = index; i < list.length; i++) {
                        list[i].getElementsByClassName('aplayer-list-index')[0].textContent = i;
                    }
                    if (this.options.audio.length === 1) {
                        this.container.classList.remove('aplayer-withlist');
                    }
                    this.template.list.style.height = parseInt(this.template.list.style.height, 10) - 33 + 'px';
                }
            }
        },
        {
            key: 'destroy',
            value: function destroy() {
                instances.splice(instances.indexOf(this), 1);
                this.pause();
                this.container.innerHTML = '';
                this.audio.src = '';
                this.timer.destroy();
                this.events.trigger('destroy');
            }
        },
        {
            key: 'handlePlayPromise',
            value: function handlePlayPromise(callback) {
                this.playedPromise = this.playedPromise.then(callback).catch(function (err) {
                    console.error(err);
                });
            }
        }
    ]);
    return APlayer;
}();
exports.default = APlayer;


//////////////////
// WEBPACK FOOTER
// ./src/js/player.js
// module id = 6
// module chunks = 0